<div #mapContainer class="ui-outlets-map-mobile__map"></div>

@if (view() === 'map') {
  <div class="ui-outlets-map-mobile__footer">
    <button type="button"
            class="ui-outlets-map-mobile__list-btn"
            [translate]="'modal.outletsMap.showStoreList'"
            (click)="showList()">
      Show store list
    </button>
  </div>
} @else if (outlets()?.length) {
  <div class="ui-outlets-map-mobile__sheet-wrap"
       [class.is-selected]="view() === 'selected'"
       [class.is-list]="view() === 'list'"
       [class.is-dragging]="dragHeight() !== null"
       [style.height.px]="dragHeight()">
    <div class="ui-outlets-map-mobile__sheet">
      <div class="ui-outlets-map-mobile__handle"
           (pointerdown)="onHandlePointerDown($event)">
        <button type="button"
                class="ui-outlets-map-mobile__map-btn"
                [translate]="'modal.outletsMap.showMap'"
                (click)="onMapBtnClick()">
          Show map
        </button>
      </div>

      <div #sheetScroll class="ui-outlets-map-mobile__cards">
        <ui-outlets-accordion
          [outlets]="outlets()"
          [scheduleOverridesByOutletId]="scheduleOverridesByOutletId()"
          [expandedOutlet]="selectedOutlet()"
          [showNext]="showNext()"
          [nextText]="nextText()"
          [isOutletSelectionStateEnabled]="isOutletSelectionStateEnabled()"
          [disabledOutletIds]="disabledOutletIds()"
          [outletAccordionOptions]="accordionOptions()"
          [scheduleType]="scheduleType()"
          (onNext)="onNext.emit($event)"
          (onScrollEmit)="scrollSheetTo($event)"
          (onOutletChanged)="onAccordionOutletChanged($event)"
        ></ui-outlets-accordion>
      </div>
    </div>
  </div>
}
